export enum AppFrame {
  Blank = 'blank',
  Frame = 'frame',
  Login = 'login'
}

export enum EUpdateFlag {
  Insert = 'I',
  Update = 'U',
  Delete = 'D'
}

export enum ItemStatus {
  None = 'None',
  New = 'New',
  Update = 'Update'
}
